<template>
  
  <div class="segnalazione" v-if="ready">
    <div class="grid mt-6">
      <div class="cell">
        <div class="has-text-centered">
          <p> {{ $t('SegnalazioneInstruction.p_1') }} </p>
          <p> {{ $t('SegnalazioneInstruction.p_2') }} </p>
          <p> {{ $t('SegnalazioneInstruction.p_3') }} </p>
        </div>
      </div>
    </div>
    
    <div class="grid">
      <div class="cell has-text-centered"> 
        <form id="webtocase_form" v-bind:action="actionURL" method="POST">
          <div class="">
            <textarea name="description" class="c-width_75" v-model="caseObj.Description" rows="3"></textarea><br>
          </div>
          
          <div v-show="false">
            <input type=hidden name="orgid" v-bind:value="org_id" >
            <input type="hidden" name="retURL" v-bind:value="returnURL" />

            <input type="text" id="subject" name="subject" v-bind:value="caseObj.Subject" />
            <input type="text" id="status" name="status" v-bind:value="caseObj.Status" />
            <input type="text" id="type" name="type" v-bind:value="caseObj.Type" />
            <input type="text" id="priority" name="priority" v-bind:value="caseObj.Priority" />
            <input type="text" id="recordType" name="recordType" v-bind:value="caseObj.recordType" />
          </div>
        </form>
      </div>
    </div>
    
    <div class="grid">
      <div class="cell has-text-centered">
        <button class="button is-link touppercase" v-bind:disabled="isFormIncomplete(caseObj)" v-on:click.prevent="submit_webToLead($event)">{{ $t('Submit') }}</button>
      </div>
    </div>
  </div>
  
</template>

<script>
import gnetMixLib from '@/mixin.js'

export default {
  name: 'Senalazione',
  mixins: [gnetMixLib],
  components: { },
  
  props: { },
  
  data: function() {
    return {
      ready: false,
      caseObj: {},
      orgId_prod: '00D1t000000ss9x',
      baseURL_prod: 'https://almascuola.my.salesforce.com',
      orgId_sandbox: '00D0Q0000008ipI',
      baseURL_sandbox: 'https://almascuola--dev2021.sandbox.my.salesforce.com',
    };
  },
  
  watch: { },
  
  computed: {
    returnURL: function() {
      return window.location.origin + '?type=typage';
    },

    org_id: function() {
      return (this.$store.getters.isSandbox) ? this.orgId_sandbox : this.orgId_prod;
    },
    
    actionURL: function() {
      let baseURL = (this.$store.getters.isSandbox) ? this.baseURL_sandbox : this.baseURL_prod;
      let url = `${baseURL}/servlet/servlet.WebToCase?encoding=UTF-8&orgId=${this.org_id}&retURL=${this.returnURL}`;
      return url;
    }
  },
  
  created: function() { },
  
  mounted: async function() {
    this.caseObj = {
      Subject: 'Segnalazione Anonima',
      Status: 'New',
      Type: 'Problem',
      Priority: 'Medium',
      Origin: 'Segnalazione',
      Description: ''
    }

    this.caseObj.recordType = (this.$store.getters.isSandbox) ? '' : '012SY000004x0OH'

    this.ready = true;
  },
  
  methods: {
    submit_webToLead: function() {
      if(this.isFormIncomplete(this.caseObj)) {
        return;
      }
      
      document.getElementById('webtocase_form').submit();
    },
    
    isFormIncomplete: function(caseObj) {
      let isIncomplete = false;
      
      if(this.isValidText(caseObj.Description) == false) isIncomplete = true;
      
      return isIncomplete;
    },
    
    isValidText: function(val) {
      return val != undefined && val != '' && val.length > 0;
    },
  },
}

</script>

<style scoped>

.notes {
  white-space: nowrap;
  margin-right: 0.1rem;
}

.valign-top {
  vertical-align: top;
}

.c-width_75 {
  width: 80vw;
}

</style>

